import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Menu = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M17.5 5a1.25 1.25 0 1 0 0-2.5h-15a1.25 1.25 0 0 0 0 2.5zm1.25 5c0 .69-.56 1.25-1.25 1.25h-15a1.25 1.25 0 1 1 0-2.5h15c.69 0 1.25.56 1.25 1.25m0 6.25c0 .69-.56 1.25-1.25 1.25h-15a1.25 1.25 0 1 1 0-2.5h15c.69 0 1.25.56 1.25 1.25" }) }));
});
Menu.displayName = 'Menu';
Menu.__iconComponentType = 'standard';
export default Menu;
//# sourceMappingURL=Menu.js.map